import { render, staticRenderFns } from "./NavModule.vue?vue&type=template&id=6af6b7a8&scoped=true"
import script from "./NavModule.vue?vue&type=script&lang=js"
export * from "./NavModule.vue?vue&type=script&lang=js"
import style0 from "./NavModule.vue?vue&type=style&index=0&id=6af6b7a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af6b7a8",
  null
  
)

export default component.exports